import React, { useEffect } from 'react'
import useApp from '../../store/app/appContext';
import PageWrapper from '../../containers/app/PageWrapper';
import { useParams, useLocation } from 'react-router' 
import ViewStaffDetails from '../../containers/staff/ViewStaffDetails';
import UsersProvider from '../../store/users/usersProvider';
import AddStaff from '../../containers/staff/AddStaff';

function StaffDetails() {
  const { id } = useParams(); 
  const location = useLocation();

  const { appState: { user }} = useApp();
  const [pageTitle, setPageTitle] = React.useState('');

  const addStaff = location.pathname.includes('/add');

  useEffect(() => {
    if (id) setPageTitle('Staff details');
    if (addStaff) setPageTitle('Add staff');
  }, [])

  if (!user) return '';
  if (!user._id) return '';

  return (
    <UsersProvider>
      <PageWrapper navbar title={pageTitle}>
        {id && <ViewStaffDetails staffId={id}/>}
        {addStaff && <AddStaff />}
      </PageWrapper>
    </UsersProvider>
  )
}

export default StaffDetails;